import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    return(
        <footer>
            <div className="container">
                <div className="row">                            
                    <div className="col-md-6 order-md-2 text-center text-md-end py-1">
                        <Link to="/" className="" title="Terms of Use">
                            Terms of Use
                        </Link>
                        <span className="mx-3">|</span>
                        <Link to="/" className="" title="Privacy Policy">
                            Privacy Policy
                        </Link>
                    </div>
                    <div className="col-md-6 text-center text-md-start py-1">
                        &copy; 2021 
                        <Link to="https://www.creditzmusic.com/" className="ms-2" title="Creditz">Creditz</Link>
                        <span className="mx-2">-</span>
                        All Rights Reserved.
                    </div>
                </div>
            </div>
        </footer>
    )
}
export default Footer;